import React, { useEffect, useRef, useState } from "react";
import { makeGet, makePost, makePatch, makeDelete } from "@culturehq/client";
import { Trans } from "app/utils";
import { Button, Loader, Panel, Table, Warning } from "@culturehq/components";
import ErrorMessage from "components/common/ErrorMessage";

import DefaultPromptModal from "./settings/default-prompts/DefaultPromptModal";
import DefaultPromptRow from "./settings/default-prompts/DefaultPromptRow";
import { DefaultPrompt, StateProps } from "./settings/default-prompts/DefaultPromptTypes";

const DefaultPrompts = () => {
  const isMounted = useRef<boolean>();
  const [{ loading, defaultPrompts, error }, setState] = useState<StateProps>({
    loading: false,
    defaultPrompts: [],
    error: undefined
  });

  const handleState = (
    newProps: Partial<StateProps>
  ) => setState(prev => ({ ...prev, ...newProps }));

  const handleFetch = () => {
    makeGet("/default_prompts").then(
      ({ defaultPrompts }: any) => isMounted.current
      && handleState({ defaultPrompts, loading: false }));
  };

  const handleCreate = ({ defaultInviterId, promptId, imageUrl, note }: any) => {
    makePost("/default_prompts", { defaultInviterId, promptId, imageUrl, note }).then(handleFetch);
  };

  const handleUpdate = ({ id, defaultInviterId, promptId, imageUrl, note }: any) => {
    makePatch(`/default_prompts/${id}`, { defaultInviterId, promptId, imageUrl, note }).then(handleFetch);
  };

  const handleDelete = ({ id }: DefaultPrompt) => {
    makeDelete(`/default_prompts/${id}`).then(handleFetch);
  };

  useEffect(() => {
    isMounted.current = true;
    handleState({ loading: true });
    handleFetch();

    return () => {
      isMounted.current = false;
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Panel limitWidth>
      <Panel.Heading primary>Default Prompts</Panel.Heading>
      <Panel.Body className="ManageUsers">
        {error && <ErrorMessage error={error} />}

        <DefaultPromptModal onCreate={handleCreate}>
          {(onTrigger: any) => (
            <Button icon="plus" primary onClick={onTrigger}>
              <Trans>Add</Trans>
            </Button>
          )}
        </DefaultPromptModal>

        <Loader loading={loading}>
          <Table className="no-scrollbar">
            <thead>
              <tr>
                <th><Trans>Inviter</Trans></th>
                <th><Trans>Prompt</Trans></th>
                <th><Trans>Image</Trans></th>
                <th><Trans>Note</Trans></th>
                <th><Trans>Created</Trans></th>
                <th><Trans>Updated</Trans></th>
                <th className="actions"><Trans>Actions</Trans></th>
              </tr>
            </thead>
            <tbody>
              {defaultPrompts.map(defaultPrompt => (
                <DefaultPromptRow
                  key={defaultPrompt.id}
                  defaultPrompt={defaultPrompt}
                  onUpdate={handleUpdate}
                  onDelete={handleDelete}
                />
              ))}
            </tbody>
          </Table>

          {!defaultPrompts.length && (
            <Warning><Trans>No results to show.</Trans></Warning>
          )}
        </Loader>
      </Panel.Body>
    </Panel>
  );
};

export default DefaultPrompts;
